"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var __1 = require("../");
var SidebarSection_1 = require("./SidebarSection");
var Sidebar = /** @class */ (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar(props) {
        var _this = _super.call(this, props) || this;
        _this.sidebarRef = react_1.default.createRef();
        _this.overlayHideDelay = 500;
        _this.overlayTimeoutHandler = null;
        _this.overlayToggle = function (e) {
            if (!_this.state.collapsed)
                return;
            if (_this.state.overlayVisible)
                return _this.overlayClose(e);
            return _this.overlayOpen();
        };
        _this.overlayOpen = function () {
            if (!_this.state.collapsed)
                return;
            clearTimeout(_this.overlayTimeoutHandler);
            document.addEventListener('click', _this.handleClickOutside);
            document.addEventListener('touchend', _this.handleClickOutside);
            _this.setState({
                overlayVisible: true,
            });
        };
        _this.overlayClose = function (e, speed) {
            if (speed === void 0) { speed = _this.overlayHideDelay; }
            if (!_this.state.collapsed)
                return;
            if (!_this.state.overlayVisible)
                return;
            _this.overlayTimeoutHandler = setTimeout(function () {
                document.removeEventListener('click', _this.handleClickOutside);
                document.removeEventListener('touchend', _this.handleClickOutside);
                _this.setState({
                    overlayVisible: false,
                });
            }, speed);
        };
        _this.handleWindowResize = utilities_1.debounce(function () {
            _this.sidebarRef.current &&
                _this.setState({ collapsed: _this.shouldBeCollapsed() });
        }, 150);
        _this.handleClickOutside = function (e) {
            var _a;
            if ((_a = _this.sidebarRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))
                return;
            _this.overlayClose(e, 0);
        };
        _this.state = {
            collapsed: props.collapsed === undefined
                ? _this.shouldBeCollapsed()
                : props.collapsed,
            overlayVisible: false,
        };
        return _this;
    }
    Sidebar.getDerivedStateFromProps = function (nextProps, state) {
        if (nextProps.collapsed !== undefined &&
            nextProps.collapsed !== state.collapsed) {
            return { collapsed: nextProps.collapsed };
        }
        return null;
    };
    Sidebar.prototype.shouldBeCollapsed = function () {
        if (this.props.collapsed !== undefined) {
            return this.props.collapsed;
        }
        if (typeof window === 'undefined')
            return false;
        /* Prefer innerWidth value, with fallback to outerWidth when inner exceeds outer. Useful on mobile/tablet scenarios when screens are zoomed out, causing the Sidebar to not collapse due to high inner value */
        var windowWidth = window.outerWidth >= window.innerWidth
            ? window.innerWidth
            : window.outerWidth;
        return windowWidth < this.props.collapseBreakpoint;
    };
    Sidebar.prototype.componentDidMount = function () {
        if (!this.props.collapsible || this.props.collapsed !== undefined)
            return;
        window.addEventListener('resize', this.handleWindowResize);
    };
    Sidebar.prototype.componentWillUnmount = function () {
        if (!this.props.collapsible)
            return;
        window.removeEventListener('resize', this.handleWindowResize);
    };
    Sidebar.prototype.render = function () {
        var _a = this.props, backgroundColor = _a.backgroundColor, children = _a.children, className = _a.className, collapsible = _a.collapsible, Element = _a.el, collapsed = _a.collapsed, collapseBreakpoint = _a.collapseBreakpoint, props = __rest(_a, ["backgroundColor", "children", "className", "collapsible", "el", "collapsed", "collapseBreakpoint"]);
        var SidebarClasses = classnames_1.default('Sidebar', className, {
            'Sidebar--collapsible': collapsible,
            'Sidebar--collapsed': collapsible && this.state.collapsed,
            'Sidebar--overlay-visible': this.state.overlayVisible,
        });
        var overlayClasses = classnames_1.default('Sidebar__overlay');
        return (react_1.default.createElement(Element, __assign({ className: SidebarClasses, ref: this.sidebarRef }, props),
            react_1.default.createElement("div", { className: "Sidebar__wrapper" },
                react_1.default.createElement(__1.Icon, { className: "Sidebar__toggle-overlay-button", name: "menu", onClick: this.overlayToggle }),
                react_1.default.createElement("div", { className: overlayClasses, onMouseOver: this.overlayOpen, onMouseLeave: this.overlayClose }, children))));
    };
    Sidebar.defaultProps = {
        collapseBreakpoint: 900,
        collapsible: true,
        el: 'div',
    };
    Sidebar.Section = SidebarSection_1.SidebarSection;
    return Sidebar;
}(react_1.Component));
exports.Sidebar = Sidebar;
//# sourceMappingURL=Sidebar.js.map